export const NavDivider: React.FC = () => (
  <div css={{ height: "1px", width: "100%", background: "rgba(0,0,0,0.1)", flexShrink: 0 }} />
);
